import React from 'react';
import { Redirect, Switch } from 'react-router-dom';

const AppSwitch = ({ children }) => {
  return (
    <Switch>
      {children}
      <Redirect from="*" to="/404-error/" />
    </Switch>
  );
};

export default AppSwitch;
